import { NgModule, ModuleWithProviders, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { forwardRef } from '@angular/core';

import { CardModule } from '../card/card.module';
import { CardFormModule } from '../cardform/cardform.module';
import { CheckboxModule } from '../checkbox/checkbox.module';
import { DateEditModule } from '../dateedit/dateedit.module';
import { EditModule } from '../edit/edit.module';
import { InteditModule } from '../intedit/intedit.module';
import { PasswordModule } from '../password/password.module';
import { LookupEditModule } from '../lookupedit/lookupedit.module';
import { GridModule } from '../grid/grid.module';
import { ReactiveformModule } from './reactiveform.module';
import { RadiobuttonModule } from '../radiobutton/radiobutton.module';
import { MemoModule } from '../memo/memo.module';
import { TagsModule } from '../tags/tags.module';
import { AutocompleteModule } from '../autocomplete/autocomplete.module';

export const DYNAMIC_DIRECTIVES = [
    forwardRef(() => CardModule),
    forwardRef(() => CardFormModule),
    forwardRef(() => CheckboxModule),
    forwardRef(() => DateEditModule),
    forwardRef(() => EditModule),
    forwardRef(() => InteditModule),
    forwardRef(() => AutocompleteModule),
    forwardRef(() => LookupEditModule),
    forwardRef(() => GridModule),
    forwardRef(() => PasswordModule),
    forwardRef(() => ReactiveformModule),
    forwardRef(() => RadiobuttonModule),
    forwardRef(() => MemoModule),
    forwardRef(() => TagsModule)
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule
    ],
    exports: [
        DYNAMIC_DIRECTIVES,
        CommonModule,
        FormsModule
    ]
})

export class SharedReactiveModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedReactiveModule
        };
    }
}
